import { isUrls } from '@/router/index.js';

export default {
    i18next: {
        ns: 'map'
    },
    props: ['css'],
    inject: ['applyMap'],
    computed: {
        isHouseDetail: () => {
            return isUrls({ names: ['listing-detail', 'sold-listing'], url: window.location.pathname });
        }
    },
    methods: {
        click() {
            return this.applyMap().then(this.handler);
        }
    }
};
